import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=b33d5482&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=b33d5482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33d5482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b33d5482')) {
      api.createRecord('b33d5482', component.options)
    } else {
      api.reload('b33d5482', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=b33d5482&scoped=true&", function () {
      api.rerender('b33d5482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21vwooRuNf4EY/JS/comp/CookieBox.vue"
export default component.exports